import { render, staticRenderFns } from "./dialog-sharefile.vue?vue&type=template&id=0d4747c6&"
import script from "./dialog-sharefile.vue?vue&type=script&lang=js&"
export * from "./dialog-sharefile.vue?vue&type=script&lang=js&"
import style0 from "./dialog-sharefile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports